import {Component, inject, OnInit} from '@angular/core';
import {LoadingComponent} from '../../../../../components/generic/loading/loading.component';
import {MessageComponent} from '../../../../../components/generic/message/message.component';
import {ViewService} from '../../../../shared/service/view.service';
import {PlayerProfileService} from '../../../service/player-profile.service';
import {RestErrorHelper} from '../../../../../helper/rest-error-helper';
import {ErrorType} from '../../../../../model/error-type';
import {Achievement} from '../../../model/achievement';
import {TableModule} from 'primeng/table';

@Component({
  selector: 'app-player-profile-achievements',
  standalone: true,
  imports: [
    LoadingComponent,
    MessageComponent,
    TableModule,
  ],
  templateUrl: './player-profile-achievements.component.html',
  styleUrl: './player-profile-achievements.component.scss'
})
export class PlayerProfileAchievementsComponent implements OnInit
{
  public view = inject(ViewService);
  public playerProfileService = inject(PlayerProfileService);
  private restErrorHelper = inject(RestErrorHelper);

  isLoading: boolean;
  errorMsg: ErrorType;
  data: Achievement[];
  scoreTotal: number;

  ngOnInit(): void
  {
    this.loadData();
  }

  private loadData(): void
  {
    this.isLoading = true;
    this.errorMsg = undefined;
    this.data = undefined;
    this.playerProfileService.getPlayerAchievements().subscribe({
      next: response =>
      {
        console.log('PlayerAchievements geladen', response);
        this.isLoading = false;
        this.data = response;
        this.initAchievements();
      },
      error: error =>
      {
        this.isLoading = false;
        console.log('Fehler bei "loadData"', error);
        this.errorMsg = this.restErrorHelper.getErrorType(error);
      }
    });
  }

  private initAchievements(): void
  {
    this.scoreTotal = 0;
    if (this.data)
    {
      for (const achievement of this.data)
      {
        if (achievement.playerAchievements)
        {
          let allSeen = true;
          for (const pa of achievement.playerAchievements)
          {
            if (pa.unlocked)
            {
              this.scoreTotal += achievement.points;
              achievement.unlocked = pa.unlocked;
              if (!pa.seen)
                allSeen = false;
            }
          }
          if (achievement.unlocked)
            achievement.seen = allSeen;
        }
      }
    }
  }
}
